// extracted by mini-css-extract-plugin
module.exports = {"homeVideo":"homeVideo_homeVideo___gG3Z"};